/* eslint-disable react/no-array-index-key */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useData } from './data';
import { useColumns } from './columns';

import styles from './styles.module.scss';

export const AgentStatusContainer = memo(() => {
  const { t } = useTranslation('welcome');
  const trans = useTranslation('main').t;
  const columns = useColumns();
  const data = useData(trans);

  return (
    <div
      id="sellers"
      className={styles.agent_status_container}
    >
      <h2>{t('Agent_title_')}</h2>
      <div className={styles.agent_status_content}>
        <div className={styles.agent_status_table}>
          <table>
            <thead>
              <tr>
                {columns.map((title, index) => (
                  <th key={index}>{title.Header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{`${row.status}`}</td>
                  <td>{row.turnover}</td>
                  <td>{row.teamTurnover}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className={styles.agent_status_content_right}>
          <p>{t('Agent_subtitle_')}</p>
          <div className={styles.agent_status_content_right_description}>
            <div className={styles.agent_status_content_right_description_details}>
              <p>2%</p>
              <span>{t('Referral_advanced_seller_')}</span>
            </div>
            <div className={styles.agent_status_content_right_description_details}>
              <p>2%</p>
              <span>{t('Referral_top_seller_')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
